let g = {
  PREVIOUS_FRAME: 2,
};

export const x1ErrorLite = {
  TAALOpcode: g,
};
